import React from 'react';
import Button from 'components/Button/Button';
import { useAppDispatch } from 'app/hooks';
import {
  saveSelectedItem,
  selectSelectedFooter,
  toggleAllVisibilityFooter,
  toggleIndividualVisibilityFooter,
} from 'features/document/documentSlice';
import { useAppSelector } from 'app/hooks';
import { ElementType, FooterElement } from 'features/document/constants';
import { useGetFileQuery } from 'features/files/filesApi';
import {
  GridContainer,
  ButtonContainer,
  Container,
  Tag,
  GridItemImage,
  GridItemText,
  Text,
  ImageElement,
  GridMessage,
  TextMessage,
} from './FooterSection.styled';

interface Props {
  footer: FooterElement;
  isIndividualFooterVisible: boolean;
  pageId: string;
  pageNumber: number;
  totalPages: number;
}

const FooterSection: React.FC<Props> = ({ footer, isIndividualFooterVisible, pageId, pageNumber, totalPages }) => {
  const dispatch = useAppDispatch();
  const selector = useAppSelector;
  const selectedItem = selector(selectSelectedFooter);
  const isSameItem = selectedItem?.data?.id == footer.id;

  const { data: backgroundImageData } = useGetFileQuery(Number(footer.content.backgroundImage.id), {
    skip: footer.content.backgroundImage.id === null,
  });

  const { data: logoData } = useGetFileQuery(Number(footer.content.logo.id), {
    skip: footer.content.logo.id === null,
  });

  const handleSelectedItem = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    e.preventDefault();
    dispatch(saveSelectedItem({ data: { data: footer, pageId, type: ElementType.Footer } }));
  };
  const { content, style } = footer;
  const handleToggleIndividualHeader = () => {
    dispatch(
      toggleIndividualVisibilityFooter({
        pageId,
        isVisible: isIndividualFooterVisible,
      })
    );
  };

  const handleToggleAllPages = () => {
    dispatch(
      toggleAllVisibilityFooter({
        isVisible: isIndividualFooterVisible,
      })
    );
  };
  return (
    <Container
      aria-hidden='true'
      onClick={handleSelectedItem}
      isSameItem={isSameItem}
      backgroundColor={content.hasBackgroundColor && isIndividualFooterVisible ? style.backgroundColor : ''}
      backgroundImage={content.hasBackgroundImage && content.backgroundImage.id ? backgroundImageData?.data.url : ''}
      isVisible={isIndividualFooterVisible}
      backgrounImageOpacity={style.backgroundImageOpacity}
      backgroundCover={style.backgroundCover}
      backgroundPosition={style.backgroundPosition}
    >
      <Tag className='containerTag' isSameItem={isSameItem}>
        Footer
      </Tag>
      <ButtonContainer isSameItem={isSameItem}>
        <Button variant='secondary' onClick={handleToggleIndividualHeader}>
          {isIndividualFooterVisible ? 'Turn off footer for this page' : 'Turn on footer for this page'}
        </Button>
        <Button
          variant='secondary'
          onClick={handleToggleAllPages}
        >{`Turn ${isIndividualFooterVisible ? 'off' : 'on'} footer for all pages`}</Button>
      </ButtonContainer>
      {isIndividualFooterVisible && (
        <GridContainer className='footer-grid-container' container justifyContent='space-between' alignItems='center'>
          <GridItemImage item xs={2} display='flex'>
            {content.hasLogo && content.logo.id && <ImageElement src={logoData?.data.url} alt='logo' />}
          </GridItemImage>
          <GridMessage item xs={8} sx={{ background: 'transparent' }}>
            {content.hasFooterText && (
              <TextMessage
                fontSize={style.textFontSize}
                fontColor={style.textColor}
                fontType={style.textFont}
                alignment={style.textAlignment}
              >
                {content.text}
              </TextMessage>
            )}
          </GridMessage>
          <GridItemText item xs={2}>
            <Text fontSize={style.labelFontSize} labelFont={style.labelFont} fontColor={style.fontColor}>
              {content.hasPageNumbering && `${pageNumber} of ${totalPages}`}
            </Text>
          </GridItemText>
        </GridContainer>
      )}
    </Container>
  );
};

export default FooterSection;
